
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/defaultPipes",
      function () {
        return require("private-next-pages/defaultPipes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/defaultPipes"])
      });
    }
  